import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'ums/v1/crm/brands/poc/calls';
export const getPocAgentCallTranscriptEndpointIdentifier = endpoint;

export interface IPocAgentCallTranscriptData {
  role: 'user' | 'agent';
  content: string;
}

type TData = IPocAgentCallTranscriptData[];

type TError = AxiosError;
type TQueryKey = [typeof endpoint, { pocCallId: number }];
type Options = Omit<UseQueryOptions<unknown, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetPocAgentCallTranscriptApi(pocCallId: number, options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();

  const queryFn = async () => {
    try {
      const { data } = await http.get(endpoint + `/${pocCallId}/transcript`);

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      throw error;
    }
  };

  return useQueryWrapper([endpoint, { pocCallId }], queryFn, {
    enabled: isLoggedIn,
    ...options,
  });
}
